import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import CommaSeparator from "../../components/CommaSeprator";

const POTableCellForPrint = ({ OrderSummarydata, TableBottomtext, props, TableTextStyle }) => {

    return (

        <TableContainer
            component={Paper}
            sx={{
                maxWidth: "100%",
                mx: "auto",
            }}
        >
            <Table
                sx={{ minWidth: "auto" }}
                aria-label="customized table"
            >
                <TableHead>
                    <TableRow
                        sx={{
                            height: "42px",
                            bgcolor: props?.SellerPage ? "#c73e91" : "#2261A2",

                        }}
                    >
                        <TableCell
                            align="center"
                            colSpan={1}
                            rowSpan={1}
                            sx={{
                                borderRight: "1px solid #CDCDCD",
                                width: "20px",
                                maxWidth: "20px",
                            }}
                        >
                            <Typography sx={TableTextStyle}>No.</Typography>
                        </TableCell>
                        <TableCell
                            align="center"
                            colSpan={1}
                            rowSpan={1}
                            maxWidth={100}
                            sx={{
                                borderRight: "1px solid #CDCDCD",
                                width: "10px",
                                maxWidth: "10px",
                            }}
                        >
                            <Typography sx={TableTextStyle}>
                                Product / Service Description
                            </Typography>
                        </TableCell>
                        <TableCell
                            align="center"
                            colSpan={1}
                            rowSpan={1}
                            sx={{
                                borderRight: "1px solid #CDCDCD",
                                width: "10px",
                                maxWidth: "10px",
                            }}
                        >
                            <Typography sx={TableTextStyle}>HSN</Typography>
                        </TableCell>
                        <TableCell
                            align="center"
                            colSpan={1}
                            rowSpan={1}
                            sx={{ borderRight: "1px solid #CDCDCD" }}
                        >
                            <Typography sx={TableTextStyle}>QTY</Typography>
                        </TableCell>
                        <TableCell
                            align="center"
                            colSpan={1}
                            rowSpan={1}
                            sx={{ borderRight: "1px solid #CDCDCD" }}
                        >
                            <Typography sx={TableTextStyle}>Rate</Typography>
                        </TableCell>
                        <TableCell
                            align="center"
                            colSpan={1}
                            rowSpan={1}
                            sx={{ borderRight: "1px solid #CDCDCD" }}
                        >
                            <Typography sx={TableTextStyle}>Amount</Typography>
                        </TableCell>
                        <TableCell
                            align="center"
                            colSpan={1}
                            rowSpan={1}
                            sx={{
                                borderRight: "1px solid #CDCDCD",
                                width: "50px",
                                maxWidth: "50px",
                            }}
                        >
                            <Typography sx={TableTextStyle}>
                                Taxable Value
                            </Typography>
                        </TableCell>
                        <TableCell
                            sx={{
                                p: 0,
                                maxWidth: "200px",
                                mx: "auto",
                            }}
                            align="center"
                        >
                            {OrderSummarydata && OrderSummarydata?.IsIGST ? (
                                <TableRow>
                                    <TableCell
                                        align="center"
                                        colSpan={2}
                                        sx={{
                                            width: "150px",
                                            borderRight: "1px solid #CDCDCD",
                                            p: 0,
                                            height: "35px",
                                        }}
                                    >
                                        <Typography sx={TableTextStyle}>
                                            IGST
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            ) : (
                                <TableRow>
                                    <TableCell
                                        align="center"
                                        colSpan={2}
                                        sx={{
                                            width: "150px",
                                            borderRight: "1px solid #CDCDCD",
                                            p: 0,
                                            height: "35px",
                                        }}
                                    >
                                        <Typography sx={TableTextStyle}>
                                            CGST
                                        </Typography>
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        colSpan={2}
                                        sx={{
                                            width: "150px",
                                            p: 0,
                                            height: "35px",
                                        }}
                                    >
                                        <Typography sx={TableTextStyle}>
                                            SGST
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            )}

                            {OrderSummarydata && OrderSummarydata?.IsIGST ? (
                                <TableRow>
                                    <TableCell
                                        align="center"
                                        sx={{
                                            borderRight: "1px solid #CDCDCD",
                                            p: 0,
                                            height: "35px",
                                            width: "25%",
                                        }}
                                    >
                                        {" "}
                                        <Typography sx={TableTextStyle}>%</Typography>
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        sx={{
                                            width: "25%",
                                            borderRight: "1px solid #CDCDCD",
                                            p: 0,
                                            height: "35px",
                                        }}
                                    >
                                        {" "}
                                        <Typography sx={TableTextStyle}>Rs.</Typography>
                                    </TableCell>
                                </TableRow>
                            ) : (
                                <TableRow>
                                    <TableCell
                                        align="center"
                                        sx={{
                                            borderRight: "1px solid #CDCDCD",
                                            p: 0,
                                            height: "35px",
                                            width: "25%",
                                        }}
                                    >
                                        {" "}
                                        <Typography sx={TableTextStyle}>%</Typography>
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        sx={{
                                            width: "25%",
                                            borderRight: "1px solid #CDCDCD",
                                            p: 0,
                                            height: "35px",
                                        }}
                                    >
                                        {" "}
                                        <Typography sx={TableTextStyle}>Rs.</Typography>
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        sx={{
                                            width: "25%",
                                            borderRight: "1px solid #CDCDCD",
                                            p: 0,
                                            height: "100%",
                                        }}
                                    >
                                        {" "}
                                        <Typography sx={TableTextStyle}>%</Typography>
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        sx={{ p: 0, height: "100%", width: "25%" }}
                                    >
                                        {" "}
                                        <Typography sx={TableTextStyle}>Rs.</Typography>
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableCell>
                        <TableCell
                            align="center"
                            sx={{
                                background: props?.SellerPage
                                    ? "#c73e91"
                                    : "#2261A2",
                                width: "170px",
                                borderLeft: "1px solid #CDCDCD",
                            }}
                        >
                            <Typography sx={TableTextStyle}>Total</Typography>
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {OrderSummarydata?.ProductData?.map((row, idx) => {
                        let TotalSec = row?.TotalSec;
                        return (
                            <React.Fragment key={idx}>
                                <TableRow
                                    sx={{
                                        height: "42px",
                                        backgroundColor: "#F7F7F7",
                                    }}
                                >
                                    <TableCell
                                        align="center"
                                        colSpan={1}
                                        rowSpan={1}
                                        sx={{ borderRight: "1px solid #CDCDCD" }}
                                    >
                                        <Typography sx={TableBottomtext}>
                                            {idx + 1}
                                        </Typography>
                                    </TableCell>
                                    <TableCell
                                        align="left"
                                        colSpan={1}
                                        rowSpan={1}
                                        sx={{ borderRight: "1px solid #CDCDCD" }}
                                    >
                                        <Typography
                                            sx={{
                                                fontSize: "12px",
                                                minWidth: "220px",
                                                maxWidth: "250px", // Prevents text from making the TableCell expand
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "flex-start",
                                                "@media print": { fontSize: "11px" },
                                            }}
                                        >
                                            {row?.ProductName}
                                        </Typography>

                                        {row?.TotalSec && (
                                            <Typography>
                                                {row?.ProductTypeId === "MediaOffline" ||
                                                    row?.ProductTypeId ===
                                                    "News Papers / Magazines"
                                                    ? `(${row?.TimelineToBought} ${row?.Timeline})`
                                                    : `(${TotalSec} sec) (${row?.TimelineToBought} ${row?.Timeline})`}
                                            </Typography>
                                        )}
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        colSpan={1}
                                        rowSpan={1}
                                        sx={{ borderRight: "1px solid #CDCDCD" }}
                                    >
                                        <Typography sx={TableBottomtext}>
                                            {row?.HSN}
                                        </Typography>
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        colSpan={1}
                                        rowSpan={1}
                                        sx={{ borderRight: "1px solid #CDCDCD" }}
                                    >
                                        <Typography sx={TableBottomtext}>
                                            <CommaSeparator Price={row?.ProductQuantity} />
                                        </Typography>
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        colSpan={1}
                                        rowSpan={1}
                                        sx={{ borderRight: "1px solid #CDCDCD" }}
                                    >
                                        <Typography sx={TableBottomtext}>
                                            <CommaSeparator
                                                Price={
                                                    row?.ProductTypeName === "Media"
                                                        ? row?.DiscountedPrice
                                                        : row?.PricePerUnitWithoutGST
                                                }
                                            />
                                        </Typography>
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        colSpan={1}
                                        rowSpan={1}
                                        sx={{ borderRight: "1px solid #CDCDCD" }}
                                    >
                                        <Typography sx={TableBottomtext}>
                                            <CommaSeparator
                                                Price={row?.TotalPriceWithoutGST}
                                            />
                                        </Typography>
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        colSpan={1}
                                        rowSpan={1}
                                        sx={{ borderRight: "1px solid #CDCDCD" }}
                                    >
                                        <Typography sx={TableBottomtext}>
                                            {" "}
                                            <CommaSeparator
                                                Price={row?.TotalPriceWithoutGST}
                                            />
                                        </Typography>
                                    </TableCell>
                                    <TableCell
                                        sx={{
                                            p: 0,
                                            maxWidth: "200px",
                                            mx: "auto",
                                        }}
                                        align="center"
                                    >
                                        {OrderSummarydata &&
                                            OrderSummarydata?.IsIGST ? (
                                            <TableRow>
                                                <TableCell
                                                    align="center"
                                                    colSpan={2}
                                                    sx={{
                                                        width: "150px",
                                                        borderRight: "1px solid #CDCDCD",
                                                    }}
                                                >
                                                    <Typography sx={TableBottomtext}>
                                                        {row?.GST}
                                                    </Typography>
                                                </TableCell>

                                                <TableCell
                                                    align="center"
                                                    colSpan={2}
                                                    sx={{
                                                        width: "150px",
                                                        borderRight: "1px solid #CDCDCD",
                                                    }}
                                                >
                                                    <Typography sx={TableBottomtext}>
                                                        <CommaSeparator
                                                            Price={row?.TotalGSTAmount}
                                                        />
                                                    </Typography>
                                                </TableCell>
                                            </TableRow>
                                        ) : (
                                            <TableRow>
                                                <TableCell
                                                    align="center"
                                                    colSpan={2}
                                                    sx={{
                                                        width: "150px",
                                                        borderRight: "1px solid #CDCDCD",
                                                    }}
                                                >
                                                    <Typography sx={TableBottomtext}>
                                                        {row?.GST / 2}
                                                    </Typography>
                                                </TableCell>

                                                <TableCell
                                                    align="center"
                                                    colSpan={2}
                                                    sx={{
                                                        width: "150px",
                                                        borderRight: "1px solid #CDCDCD",
                                                    }}
                                                >
                                                    <Typography sx={TableBottomtext}>
                                                        <CommaSeparator
                                                            Price={row?.TotalGSTAmount / 2}
                                                        />
                                                    </Typography>
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    colSpan={2}
                                                    sx={{
                                                        width: "150px",
                                                        borderRight: "1px solid #CDCDCD",
                                                    }}
                                                >
                                                    <Typography sx={TableBottomtext}>
                                                        {row?.GST / 2}
                                                    </Typography>
                                                </TableCell>

                                                <TableCell
                                                    align="center"
                                                    colSpan={2}
                                                    sx={{
                                                        width: "150px",
                                                        borderRight: "1px solid #CDCDCD",
                                                    }}
                                                >
                                                    <Typography sx={TableBottomtext}>
                                                        <CommaSeparator
                                                            Price={row?.TotalGSTAmount / 2}
                                                        />
                                                    </Typography>
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        colSpan={1}
                                        rowSpan={1}
                                        sx={{ borderRight: "1px solid #CDCDCD" }}
                                    >
                                        <Typography sx={TableBottomtext}>
                                            <CommaSeparator
                                                Price={row?.TotalPriceWithGSTInBXI}
                                            />
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                                {row?.AdditionCost?.AdditionCostArray?.map(
                                    (res, index) => {
                                        let GstOfAdCost = Number(res?.AdCostGST);
                                        return (
                                            <TableRow
                                                sx={{
                                                    height: "25px",
                                                    padding: 0,
                                                    margin: 0,
                                                }}
                                                key={index}
                                            >
                                                <TableCell
                                                    align="center"
                                                    colSpan={1}
                                                    rowSpan={1}
                                                    sx={{
                                                        borderRight: "1px solid #CDCDCD",
                                                        padding: 0,
                                                        margin: 0,
                                                    }}
                                                ></TableCell>
                                                <TableCell
                                                    align="left"
                                                    colSpan={1}
                                                    rowSpan={1}
                                                    sx={{
                                                        borderRight: "1px solid #CDCDCD",
                                                        padding: 0,
                                                        margin: 0,
                                                        px: 1,
                                                    }}
                                                >
                                                    <Typography
                                                        sx={{
                                                            fontSize: "12px",
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis",
                                                            whiteSpace: "nowrap",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "flex-start",
                                                            "@media print": { fontSize: "11px" },
                                                        }}
                                                    >
                                                        {" "}
                                                        {res?.ReasonOfCost} {"  "}({" "}
                                                        {res?.AdCostApplicableOn === "PerUnit"
                                                            ? "Per Unit"
                                                            : "One Time"}{" "}
                                                        ){" "}
                                                        {res?.currencyType === "₹" ? (
                                                            "₹"
                                                        ) : (
                                                            <img
                                                                src={BxiCoin}
                                                                style={{
                                                                    width: "20px",
                                                                    height: "auto",
                                                                }}
                                                            />
                                                        )}{" "}
                                                    </Typography>

                                                    {row?.TotalSec && (
                                                        <Typography>
                                                            {row?.ProductTypeId ===
                                                                "MediaOffline" ||
                                                                row?.ProductTypeId ===
                                                                "News Papers / Magazines"
                                                                ? `(${row?.TimelineToBought} ${row?.Timeline})`
                                                                : `(${TotalSec} sec) (${row?.TimelineToBought} ${row?.Timeline})`}
                                                        </Typography>
                                                    )}
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    colSpan={1}
                                                    rowSpan={1}
                                                    sx={{
                                                        borderRight: "1px solid #CDCDCD",
                                                        padding: 0,
                                                        margin: 0,
                                                    }}
                                                >
                                                    <Typography>{res?.AdCostHSN}</Typography>
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    colSpan={1}
                                                    rowSpan={1}
                                                    sx={{
                                                        borderRight: "1px solid #CDCDCD",
                                                        padding: 0,
                                                        margin: 0,
                                                    }}
                                                >
                                                    <Typography>-</Typography>
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    colSpan={1}
                                                    rowSpan={1}
                                                    sx={{
                                                        borderRight: "1px solid #CDCDCD",
                                                        padding: 0,
                                                        margin: 0,
                                                    }}
                                                >
                                                    <Typography>
                                                        <CommaSeparator
                                                            Price={res?.PriceWithoutGST}
                                                        />
                                                    </Typography>
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    colSpan={1}
                                                    rowSpan={1}
                                                    sx={{
                                                        borderRight: "1px solid #CDCDCD",
                                                        padding: 0,
                                                        margin: 0,
                                                    }}
                                                >
                                                    <Typography>
                                                        <CommaSeparator
                                                            Price={res?.TotalTaxableAmount}
                                                        />
                                                    </Typography>
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    colSpan={1}
                                                    rowSpan={1}
                                                    sx={{
                                                        borderRight: "1px solid #CDCDCD",
                                                        padding: 0,
                                                        margin: 0,
                                                    }}
                                                >
                                                    <Typography>
                                                        <CommaSeparator
                                                            Price={res?.TotalTaxableAmount}
                                                        />
                                                    </Typography>
                                                </TableCell>
                                                <TableCell
                                                    sx={{
                                                        maxWidth: "200px",
                                                        mx: "auto",
                                                        padding: 0,
                                                        margin: 0,
                                                    }}
                                                    align="center"
                                                >
                                                    {OrderSummarydata &&
                                                        OrderSummarydata?.IsIGST ? (
                                                        <TableRow>
                                                            <TableCell
                                                                align="center"
                                                                colSpan={2}
                                                                sx={{
                                                                    padding: 0,
                                                                    width: "150px",
                                                                    borderRight: "1px solid #CDCDCD",
                                                                    margin: 0,
                                                                }}
                                                            >
                                                                <Typography>
                                                                    <CommaSeparator
                                                                        Price={GstOfAdCost}
                                                                    />
                                                                </Typography>
                                                            </TableCell>

                                                            <TableCell
                                                                align="center"
                                                                colSpan={2}
                                                                sx={{
                                                                    padding: 0,
                                                                    width: "150px",
                                                                    borderRight: "1px solid #CDCDCD",
                                                                    margin: 0,
                                                                }}
                                                            >
                                                                <Typography>
                                                                    {res?.AdCostApplicableOn ===
                                                                        "PerUnit" ? (
                                                                        <CommaSeparator
                                                                            Price={
                                                                                res?.PriceWithoutGST *
                                                                                row?.ProductQuantity *
                                                                                (GstOfAdCost / 100)
                                                                            }
                                                                        />
                                                                    ) : (
                                                                        <CommaSeparator
                                                                            Price={
                                                                                res?.PriceWithoutGST *
                                                                                (GstOfAdCost / 100)
                                                                            }
                                                                        />
                                                                    )}
                                                                </Typography>
                                                            </TableCell>
                                                        </TableRow>
                                                    ) : (
                                                        <TableRow>
                                                            <TableCell
                                                                align="center"
                                                                colSpan={2}
                                                                sx={{
                                                                    padding: 0,
                                                                    width: "150px",
                                                                    borderRight: "1px solid #CDCDCD",
                                                                    margin: 0,
                                                                }}
                                                            >
                                                                <Typography>
                                                                    <CommaSeparator
                                                                        Price={GstOfAdCost / 2}
                                                                    />
                                                                </Typography>
                                                            </TableCell>

                                                            <TableCell
                                                                align="center"
                                                                colSpan={2}
                                                                sx={{
                                                                    padding: 0,
                                                                    width: "150px",
                                                                    borderRight: "1px solid #CDCDCD",
                                                                    margin: 0,
                                                                }}
                                                            >
                                                                <Typography>
                                                                    {res?.AdCostApplicableOn ===
                                                                        "PerUnit" ? (
                                                                        <CommaSeparator
                                                                            Price={
                                                                                (res?.PriceWithoutGST *
                                                                                    row?.ProductQuantity *
                                                                                    (GstOfAdCost / 100)) /
                                                                                2
                                                                            }
                                                                        />
                                                                    ) : (
                                                                        <CommaSeparator
                                                                            Price={
                                                                                (res?.PriceWithoutGST *
                                                                                    (GstOfAdCost / 100)) /
                                                                                2
                                                                            }
                                                                        />
                                                                    )}
                                                                </Typography>
                                                            </TableCell>
                                                            <TableCell
                                                                align="center"
                                                                colSpan={2}
                                                                sx={{
                                                                    padding: 0,
                                                                    width: "150px",
                                                                    borderRight: "1px solid #CDCDCD",
                                                                    margin: 0,
                                                                }}
                                                            >
                                                                <Typography>
                                                                    <CommaSeparator
                                                                        Price={GstOfAdCost / 2}
                                                                    />
                                                                </Typography>
                                                            </TableCell>

                                                            <TableCell
                                                                align="center"
                                                                colSpan={2}
                                                                sx={{
                                                                    padding: 0,
                                                                    width: "150px",
                                                                    borderRight: "1px solid #CDCDCD",
                                                                    margin: 0,
                                                                }}
                                                            >
                                                                <Typography>
                                                                    {res?.AdCostApplicableOn ===
                                                                        "PerUnit" ? (
                                                                        <CommaSeparator
                                                                            Price={
                                                                                (res?.PriceWithoutGST *
                                                                                    row?.ProductQuantity *
                                                                                    (GstOfAdCost / 100)) /
                                                                                2
                                                                            }
                                                                        />
                                                                    ) : (
                                                                        <CommaSeparator
                                                                            Price={
                                                                                (res?.PriceWithoutGST *
                                                                                    (GstOfAdCost / 100)) /
                                                                                2
                                                                            }
                                                                        />
                                                                    )}
                                                                </Typography>
                                                            </TableCell>
                                                        </TableRow>
                                                    )}
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    colSpan={1}
                                                    rowSpan={1}
                                                    sx={{
                                                        borderRight: "1px solid #CDCDCD",
                                                        padding: 0,
                                                        margin: 0,
                                                        height: "10px",
                                                    }}
                                                >
                                                    <Typography>
                                                        <CommaSeparator
                                                            Price={
                                                                row?.ProductTypeName === "Media"
                                                                    ? TotalTokanAmount
                                                                    : res?.TotalWithGst
                                                            }
                                                        />
                                                    </Typography>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    }
                                )}
                            </React.Fragment>
                        );
                    })}
                    <TableRow
                        sx={{
                            height: "42px",
                            backgroundColor: "#F7F7F7",
                        }}
                    >
                        <TableCell
                            align="center"
                            colSpan={3}
                            rowSpan={3}
                            sx={{
                                borderRight: "1px solid #CDCDCD",
                                background: props?.SellerPage
                                    ? "#c73e91"
                                    : "#2261A2",
                            }}
                        >
                            <Typography
                                sx={{ ...TableBottomtext, color: "white" }}
                            >
                                Total
                            </Typography>
                        </TableCell>

                        <TableCell
                            align="center"
                            colSpan={1}
                            rowSpan={1}
                            sx={{ borderRight: "1px solid #CDCDCD" }}
                        >
                            <Typography
                                sx={{
                                    ...TableBottomtext,
                                    color: "rgba(5, 5, 5, 1)",
                                    opacity: 1,
                                }}
                            >
                                <CommaSeparator
                                    Price={OrderSummarydata?.POTotals?.TotalQuantity}
                                />
                            </Typography>
                        </TableCell>
                        <TableCell
                            align="center"
                            colSpan={1}
                            rowSpan={1}
                            sx={{ borderRight: "1px solid #CDCDCD" }}
                        >
                            <Typography
                                sx={{
                                    ...TableBottomtext,
                                    color: "rgba(5, 5, 5, 1)",
                                    opacity: 1,
                                }}
                            >
                                <CommaSeparator
                                    Price={
                                        OrderSummarydata?.POTotals
                                            ?.TotalPricePerUnitWithoutGST +
                                        OrderSummarydata?.POTotals
                                            ?.TotalTaxableAdditionalCost
                                    }
                                />
                            </Typography>
                        </TableCell>
                        <TableCell
                            align="center"
                            colSpan={1}
                            rowSpan={1}
                            sx={{ borderRight: "1px solid #CDCDCD" }}
                        >
                            <Typography
                                sx={{
                                    ...TableBottomtext,
                                    color: "rgba(5, 5, 5, 1)",
                                    opacity: 1,
                                }}
                            >
                                <CommaSeparator
                                    Price={
                                        OrderSummarydata?.POTotals?.TotalProductCoins +
                                        OrderSummarydata?.POTotals
                                            ?.TotalAdditionalCostWtihoutGSTInRupee +
                                        OrderSummarydata?.POTotals
                                            ?.TotalAdditionalCostWtihoutGSTInBXI
                                    }
                                />
                            </Typography>
                        </TableCell>
                        <TableCell
                            align="center"
                            colSpan={1}
                            rowSpan={1}
                            sx={{ borderRight: "1px solid #CDCDCD" }}
                        >
                            <Typography
                                sx={{
                                    ...TableBottomtext,
                                    color: "rgba(5, 5, 5, 1)",
                                    opacity: 1,
                                }}
                            >
                                <CommaSeparator
                                    Price={
                                        OrderSummarydata?.POTotals?.TotalProductCoins +
                                        OrderSummarydata?.POTotals
                                            ?.TotalAdditionalCostWtihoutGSTInRupee +
                                        OrderSummarydata?.POTotals
                                            ?.TotalAdditionalCostWtihoutGSTInBXI
                                    }
                                />
                            </Typography>
                        </TableCell>
                        <TableCell
                            sx={{
                                p: 0,
                                maxWidth: "200px",
                                mx: "auto",
                            }}
                            align="center"
                        >
                            {OrderSummarydata && OrderSummarydata?.IsIGST ? (
                                <TableRow>
                                    <TableCell
                                        align="center"
                                        colSpan={2}
                                        sx={{
                                            width: "100px",
                                            borderRight: "1px solid #CDCDCD",
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                ...TableBottomtext,
                                                color: "rgba(5, 5, 5, 1)",
                                                opacity: 1,
                                            }}
                                        >
                                            {/* <CommaSeparator Price={totalIGSTPercentage} /> */}
                                        </Typography>
                                    </TableCell>

                                    <TableCell
                                        align="center"
                                        colSpan={2}
                                        sx={{
                                            width: "100px",
                                            borderRight: "1px solid #CDCDCD",
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                ...TableBottomtext,
                                                color: "rgba(5, 5, 5, 1)",
                                                opacity: 1,
                                            }}
                                        >
                                            <CommaSeparator
                                                Price={
                                                    OrderSummarydata?.POTotals
                                                        ?.TotalGstAmount +
                                                    OrderSummarydata?.POTotals
                                                        ?.TotalAdCostGstAmount
                                                }
                                            />
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            ) : (
                                <TableRow>
                                    <TableCell
                                        align="center"
                                        colSpan={2}
                                        sx={{
                                            width: "100px",
                                            borderRight: "1px solid #CDCDCD",
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                ...TableBottomtext,
                                                color: "rgba(5, 5, 5, 1)",
                                                opacity: 1,
                                            }}
                                        >
                                            {/* <CommaSeparator Price={totalCSTPerCentage} /> */}
                                        </Typography>
                                    </TableCell>

                                    <TableCell
                                        align="center"
                                        colSpan={2}
                                        sx={{
                                            width: "100px",
                                            borderRight: "1px solid #CDCDCD",
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                ...TableBottomtext,
                                                color: "rgba(5, 5, 5, 1)",
                                                opacity: 1,
                                            }}
                                        >
                                            <CommaSeparator
                                                Price={
                                                    OrderSummarydata?.POTotals
                                                        ?.TotalGstAmount /
                                                    2 +
                                                    OrderSummarydata?.POTotals
                                                        ?.TotalAdCostGstAmount /
                                                    2
                                                }
                                            />
                                        </Typography>
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        colSpan={2}
                                        sx={{
                                            width: "100px",
                                            borderRight: "1px solid #CDCDCD",
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                ...TableBottomtext,
                                                color: "rgba(5, 5, 5, 1)",
                                                opacity: 1,
                                            }}
                                        >
                                            {/* <CommaSeparator Price={totalSGSTPercentage} /> */}
                                        </Typography>
                                    </TableCell>

                                    <TableCell
                                        align="center"
                                        colSpan={2}
                                        sx={{
                                            width: "100px",
                                            borderRight: "1px solid #CDCDCD",
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                ...TableBottomtext,
                                                color: "rgba(5, 5, 5, 1)",
                                                opacity: 1,
                                            }}
                                        >
                                            <CommaSeparator
                                                Price={
                                                    OrderSummarydata?.POTotals
                                                        ?.TotalGstAmount /
                                                    2 +
                                                    OrderSummarydata?.POTotals
                                                        ?.TotalAdCostGstAmount /
                                                    2
                                                }
                                            />
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableCell>
                        <TableCell
                            align="center"
                            colSpan={1}
                            rowSpan={1}
                            sx={{ borderRight: "1px solid #CDCDCD" }}
                        >
                            <Typography
                                sx={{
                                    ...TableBottomtext,
                                    color: "rgba(5, 5, 5, 1)",
                                    opacity: 1,
                                }}
                            >
                                <CommaSeparator
                                    Price={OrderSummarydata?.POTotals?.GrandTotal}
                                />
                            </Typography>
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>

    )
}

export default POTableCellForPrint;